import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { TextField } from '@material-ui/core';
import Tooltip from 'react-bootstrap/Tooltip';
import { useHistory } from 'react-router-dom';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { Button, Dropdown } from 'react-bootstrap';
import { groupBy } from 'lodash';
import moment from 'moment';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import TableGridWithFeatures from '../../../../SharedModules/Table/TableGridWithFeatures';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import { AllQuarterDrug, IncludeActivityTableHead } from './TableHead';
import {
  dispatchMailOut,
  getDisplayRecapGrid,
  getIncludeActivity,
  getIncludeActivityDetailsChecked,
  getRecapMailoutDate,
  setLoading,
  updateRecapMailoutDate,
} from '../Store/action';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import {
  getDisputeNdcDetails,
  singleDisputeNDCDetails,
  statusType,
} from '../../../Research/Disputes/store/actions';
import {
  MNFC_NDC_ERROR_MSG,
  START_DATE_INVALID,
} from '../../../../SharedModules/Errors/constantMessageData';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import {
  autoFormateDate,
  checkActionAccessByRole,
  validateDate,
} from '../../../../SharedModules/utilities/utilities';
import CommonModal from '../../../../SharedModules/Dialog/CommonModal';

const DisplayDisputeRecapitulation = (props) => {
  const { kcRoles } = useSelector((state) => state.sharedState.SharedReducer);
  const requestCurrentDisData = useSelector(
    (state) =>
      state?.sharedState?.DisputeRecapReducer?.performDisputeResolutionObj
        ?.state
  );
  const recentlyClosedCheckbox = useSelector(
    (state) => state?.sharedState?.DisputeRecapReducer?.checkedValue
  );
  const [hasAccess, setHasAccess] = useState(
    checkActionAccessByRole(process.env.REACT_APP_REPORT_ROLE, kcRoles)
  );
  const {
    displayObj: {
      rebateProgramName: getRebateProgramName,
      recapGrid: getDisplayRecapGridList,
      allManufacturer: manufactureName,
      manufactureWithIds: manufactureID,
    },
    includeActivity: getIncludeActivityList,
    checkBox: checkBoxRedValue,
    isLoading,
    activitytbldata,
  } = useSelector((state) => state?.sharedState?.DisputeRecapReducer);
  const getDRAMSListData = useSelector(
    (state) => state?.sharedState?.DisputeRecapReducer?.dramsInvoice
  );
  const updatedRecapMail = useSelector(
    (state) => state?.sharedState?.DisputeRecapReducer?.updatedRecapMail
  );
  // const spinnerLoader = useSelector((state) => {
  //   return state?.sharedState.showPreLoader?.showPreLoader;
  // });
  // console.log(manufactureID);
  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [includeData, setIncludeData] = React.useState([]);
  const [getSelectedRow, setGetSelectedRow] = React.useState('');
  const [errorMessage, setErrorMessage] = React.useState('');
  const [openDlg, setOpenDlg] = React.useState(false);
  const [opnNullDlg, setOpnNullDlg] = React.useState(false);
  const [dlgErr, setDlgErr] = React.useState(false);
  const [dlgTxt, setDlgTxt] = React.useState(moment().format('MM/DD/YYYY'));
  const history = useHistory();
  const dispatch = useDispatch();

  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };

  // current quarter
  const today = new Date();
  const quarter = Math.floor(today.getMonth() / 3) + 1;
  const year = today.getFullYear();
  const quarterString = quarter.toString();
  const yearString = year.toString();
  const formattedQuarter = quarterString.padStart(2);

  const currentQuarterWithYear = `${formattedQuarter}Q${yearString}`;
  const rc = recentlyClosedCheckbox;

  const rClosed = rc === true ? 'R' : 'C';
  const drugSel =
    rc === true && requestCurrentDisData?.drugSelected === 'Current Disputes'
      ? rClosed
      : requestCurrentDisData?.drugSelected
          ?.replace('All Drugs', 'D')
          ?.replace('All Disputes', 'P')
          ?.replace('Current Disputes', 'C');

  const qtrSel = requestCurrentDisData?.qtrSelected
    ?.replace('All', 'A')
    ?.replace('DRAMS Invoice Start Quarter', 'S')
    ?.replace('Selected Quarter Range', 'R');
  const dateRange = {
    'DRAMS Invoice Start Quarter': {
      beginDate: getDRAMSListData?.dramsInvoiceStartQuarter,
      endDate: currentQuarterWithYear,
    },
    All: {
      beginDate: null,
      endDate: null,
    },
    'Selected Quarter Range': {
      beginDate: requestCurrentDisData?.startingQtr,
      endDate:
        requestCurrentDisData?.endingQtr != ''
          ? requestCurrentDisData?.endingQtr
          : currentQuarterWithYear,
    },
  };
  // React.useEffect(() => {
  //   if (checkBoxRedValue == true) {
  //     dispatch(
  //       getIncludeActivity({
  //         mfgId: manufactureID[0]?.manufacturerID,
  //         rebateProgramCode: getRebateProgramName?.rebateProgramCd,
  //         startQtr: dateRange[requestCurrentDisData?.qtrSelected]?.beginDate,
  //         endQtr: dateRange[requestCurrentDisData?.qtrSelected]?.endDate,
  //         asQtrOpt: qtrSel,
  //         asDrugSel: drugSel,
  //       })
  //     );
  //   }
  // }, []);
  React.useEffect(() => {
    let data =
      getIncludeActivityList?.rebateRecapActivityDetailsCheckedVO || [];

    data = data?.map((item) => {
      return {
        ...item,
        quarterNdc: `${item.daInvQtr}_${item.ndc}`,
      };
    });
    const groupedData = groupBy(data, 'quarterNdc');

    setIncludeData(groupedData);
  }, [getIncludeActivityList]);

  // handing Go to NDCDetails redirection
  // const handleGotoNDCDetails = () => {
  //   redirectURLLink('/Wip', 'Work In Progress', history);
  // };
  // action to navigate to disputes based on NDC
  const handleGotoNDCDetails = async (data) => {
    setErrorMessage('');

    const payload = {
      qtr: data.qtr,
      secUserId: data.assignedUserID,
      rpc: getRebateProgramName?.rebateProgramCd,
      mfgId: manufactureID[0]?.manufacturerID,
      status: 'A',
    };

    const response = await dispatch(getDisputeNdcDetails(payload));
    if (response?.payload?.length > 0) {
      dispatch(
        singleDisputeNDCDetails({
          ...data,
          rebateProgramCd: getRebateProgramName?.rebateProgramCd,
          mfgId: manufactureID[0]?.manufacturerID,
          corpName: manufactureID[0]?.manufacturerName,
          ccOpenAmt: `$ ${data.paidAmt}`,
        })
      );
      dispatch(
        statusType({
          open: true,
          closed: false,
        })
      );
      const updateTabs =
        JSON.parse(localStorage.getItem('tabItemsData')) === null
          ? []
          : JSON.parse(localStorage.getItem('tabItemsData'));
      updateTabs.push({
        navTo: '/NDCDisputesDetails',
        value: 'View NDC Disputes Details',
      });
      localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
      props.history.push({
        pathname: '/NDCDisputesDetails',
      });
    } else {
      setErrorMessage(MNFC_NDC_ERROR_MSG);
      window.scrollTo(0, 0);
    }
  };
  const mNamePayload = manufactureID.map((item) => item.manufacturerName);

  const drgData = getDisplayRecapGridList?.rebateRecapGridVO ?? [];
  const formattedData = drgData.map((obj) => {
    const formattedObj = {};
    for (const key in obj) {
      if (key === 'curr_Inv' || key === 'paidAmt' || key === 'bal_Due') {
        formattedObj[key] = obj[key] ? obj[key] : '0.00';
      } else {
        formattedObj[key] = obj[key];
      }
    }
    return formattedObj;
  });
  const firstInfo = `Quarters: ${
    requestCurrentDisData?.qtrSelected === 'Selected Quarter Range'
      ? `${requestCurrentDisData?.startingQtr} - ${requestCurrentDisData?.endingQtr}`
      : requestCurrentDisData?.qtrSelected
  } `;
  const secondInfo = `Drug Selection: ${requestCurrentDisData?.drugSelected}`;
  const thirdInfo = `${getRebateProgramName?.rebateProgramCd} - ${getRebateProgramName?.shortDescr}`;
  const fourthInfo = `Manufacturer : ${mNamePayload}`;
  const [selectedDropdownOption, setSelectedDropdownOption] = useState(null);

  const handleDropdownSelection = (option, info) => {
    // setGetSelectedRow(`${info?.data?.qtr}_${info?.data?.ndc}`);
    dispatch(setLoading(true));
    setSelectedDropdownOption(option);
    dispatch(
      getIncludeActivityDetailsChecked({
        mfgId: manufactureID[0]?.manufacturerID,
        rebateProgramCode: getRebateProgramName?.rebateProgramCd,
        startQtr: dateRange[requestCurrentDisData?.qtrSelected]?.beginDate,
        endQtr: dateRange[requestCurrentDisData?.qtrSelected]?.endDate,
        asQtrOpt: qtrSel,
        asDrugSel: drugSel,
        drugSeqNum: info.data.drugSeqNum,
      })
    );
  };

  const mailoutHandler = () => {
    dispatch(setLoading(true));
    dispatch(
      getRecapMailoutDate({
        mfgId: manufactureID[0]?.manufacturerID,
        rebateProgramCode: getRebateProgramName?.rebateProgramCd,
        startQtr: dateRange[requestCurrentDisData?.qtrSelected]?.beginDate,
        endQtr: dateRange[requestCurrentDisData?.qtrSelected]?.endDate,
        asQtrOpt: qtrSel,
        asDrugSel: drugSel,
      })
    );
  };
 
  React.useEffect(() => {
    if (updatedRecapMail) {
      setDlgTxt(moment().format('MM/DD/YYYY'));
      setOpenDlg(true);
      // setTimeout(() => dispatch(dispatchMailOut(null)), 1000);
    } else if (updatedRecapMail === false) {
      setOpnNullDlg(true);
      // setTimeout(() => dispatch(dispatchMailOut(null)), 1000);
    }
    dispatch(dispatchMailOut(null));
  }, [updatedRecapMail]);

  React.useState(() => {
    dispatch(setLoading(false));
  }, [activitytbldata]);
  return (
    <div className="tabs-container">
      <Spinner load={isLoading} />
      <CustomSeparator
        parent1="Detail Reports"
        parent2="Display Dispute Recapitulation"
      />
      {errorMessage && <DisplayErrorMessages errorMessages={[errorMessage]} />}
      <div className="tab-body">
        {!fullScreenView && (
          <>
            <div className="row">
              <div className="col-12  ">
                <div className="form-wrapper p-0 mt-2">
                  <div className="mui-custom-form input-md field-xl">
                    <div className="row mb-2">
                      <div className="col-4">
                        <TextField
                          label="Rebate Program : "
                          id="Rebate Program : "
                          fullWidth
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          value={`${getRebateProgramName?.rebateProgramCd} - ${getRebateProgramName?.shortDescr}`}
                        />
                      </div>
                      <div className="col-4">
                        <TextField
                          label="Requested Quarters : "
                          id="Requested Quarters : "
                          fullWidth
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          value={
                            requestCurrentDisData?.qtrSelected ===
                            'Selected Quarter Range'
                              ? `${requestCurrentDisData?.startingQtr} - ${requestCurrentDisData?.endingQtr}`
                              : requestCurrentDisData?.qtrSelected
                          }
                        />
                      </div>
                      <div className="col-4 mb-3">
                        <TextField
                          label=" Manufacturer : "
                          id="Manufacturer : "
                          fullWidth
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          value={mNamePayload}
                        />
                      </div>

                      <div className="col-4 mb-3">
                        <TextField
                          label=" Drug Selection : "
                          id="Drug Selection :"
                          fullWidth
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          value={
                            drugSel == 'R' &&
                            requestCurrentDisData?.drugSelected ===
                              'Current Disputes'
                              ? 'Current and Recently Closed Disputes'
                              : requestCurrentDisData?.drugSelected
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}

        {checkBoxRedValue == true && (
          <div className="panel-body FRR-custom-table tbl-manufacturer-inner">
            <TableGridWithFeatures
              gridHeight={viewPortHeight_355}
              columnDefs={AllQuarterDrug}
              rowData={formattedData?.map((item) => {
                return {
                  ...item,
                  origDispUnits:
                    item.origDispUnits === null
                      ? '0.0000'
                      : item.origDispUnits.toFixed(4),
                  disputedUnits:
                    item.disputedUnits === null
                      ? '0.0000'
                      : item.disputedUnits.toFixed(4),
                };
              })}
              rowMultiSelectWithClick
              data-testid="onEditingStopped"
              fullScreenView={fullScreenView}
              showMailoutOptions={true}
              mailoutHandler={mailoutHandler}
              handleFullScreenViewClick={handleFullScreenView}
              enterMovesDown
              showResetFilter={false}
              defaultCol={{
                wrapHeaderText: true,
                autoHeaderHeight: true,
              }}
              hideColumnsInPdf
              hideTotalCount={false}
              exportFile
              fileName="Dispute Recapitulation"
              reportName="Dispute Recapitulation Report"
              isScrollOn
              defaultColWidth={200}
              frameworkComponents={{
                ActionCellRender: (cellInfo) => {
                  return (
                    <div className="tdCell icon-btn-group">
                      <Dropdown className="icon-dropdown-container ml-2">
                        <Dropdown.Toggle
                          className="icon-dropdown"
                          aria-label="Export"
                        >
                          <OverlayTrigger
                            placement="bottom"
                            overlay={
                              <Tooltip id="action-tooltip">Action</Tooltip>
                            }
                          >
                            <SVGComponent iconName="Icon-export1" />
                          </OverlayTrigger>
                        </Dropdown.Toggle>

                        <Dropdown.Menu className="export_dropdown h-auto">
                          <Dropdown.Item
                            role="button"
                            onClick={() => {
                              handleDropdownSelection(
                                'Show Drug Activity',
                                cellInfo
                              );
                            }}
                          >
                            {' '}
                            Show Drug Activity
                          </Dropdown.Item>
                          <Dropdown.Item
                            role="button"
                            onClick={() => {
                              handleGotoNDCDetails(cellInfo.data);
                            }}
                          >
                            {' '}
                            Go to NDC Dispute details
                          </Dropdown.Item>
                          {/* <Dropdown.Item
                            role="button"
                            onClick={() => {
                              // dispatch(updateRecapMailoutDate());
                              setOpenDlg(true);
                            }}
                          >
                            {' '}
                            Record Recap Mailout Date
                          </Dropdown.Item> */}
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  );
                },
              }}
              info={{ thirdInfo }}
            />{' '}
            {selectedDropdownOption === 'Show Drug Activity' && (
              <TableGridWithFeatures
                gridHeight={viewPortHeight_355}
                columnDefs={IncludeActivityTableHead}
                rowData={
                  activitytbldata?.map((item) => {
                    return {
                      ...item,
                      daUnits: item.daUnits?.toFixed(4),
                      daUra: item.daUra?.toFixed(4),
                      daChangeUnits: !item.daChangeUnits
                        ? '0.0000'
                        : item.daChangeUnits?.toFixed(4),
                      // disputedUnits: item.disputedUnits.toFixed(4),
                    };
                  }) || []
                }
                rowMultiSelectWithClick
                data-testid="onEditingStopped"
                fullScreenView={fullScreenView}
                handleFullScreenViewClick={handleFullScreenView}
                enterMovesDown
                showResetFilter={false}
                defaultCol={{
                  wrapHeaderText: true,
                  autoHeaderHeight: true,
                }}
                frameworkComponents={{
                  TextBoxRender: (cellInfo) => {
                    const name = cellInfo?.value;
                    if (name && name.length > 20) {
                      return (
                        <OverlayTrigger
                          placement="bottom"
                          overlay={
                            <Tooltip id="labeler-tooltip">{name}</Tooltip>
                          }
                        >
                          <div>{name}</div>
                        </OverlayTrigger>
                      );
                    }
                    return <div>{name}</div>;
                  },
                }}
                hideColumnsInPdf
                hideTotalCount={false}
                exportFile
                fileName="Dispute Recapitulation"
                reportName="Dispute Recapitulation Report"
                isScrollOn
                info={{ firstInfo, secondInfo, thirdInfo, fourthInfo }}
              />
            )}
          </div>
        )}
        {checkBoxRedValue == false && (
          <div className="panel-body FRR-custom-table tbl-manufacturer-inner">
            <TableGridWithFeatures
              gridHeight={viewPortHeight_355}
              columnDefs={AllQuarterDrug}
              rowData={formattedData?.map((item) => {
                return {
                  ...item,
                  origDispUnits:
                    item.origDispUnits === null
                      ? '0.0000'
                      : item.origDispUnits.toFixed(4),
                  disputedUnits:
                    item.disputedUnits === null
                      ? '0.0000'
                      : item.disputedUnits.toFixed(4),
                };
              })}
              rowMultiSelectWithClick
              data-testid="onEditingStopped"
              fullScreenView={fullScreenView}
              handleFullScreenViewClick={handleFullScreenView}
              enterMovesDown
              showResetFilter={false}
              showMailoutOptions={true}
              mailoutHandler={mailoutHandler}
              defaultCol={{
                wrapHeaderText: true,
                autoHeaderHeight: true,
              }}
              isScrollOn
              hideColumnsInPdf
              hideTotalCount={false}
              exportFile
              fileName="Dispute Recapitulation"
              reportName="Dispute Recapitulation Report"
              frameworkComponents={{
                ActionCellRender: (cellInfo) => {
                  return (
                    <div className="tdCell icon-btn-group">
                      <Dropdown className="icon-dropdown-container ml-2">
                        <Dropdown.Toggle
                          className="icon-dropdown"
                          aria-label="Export"
                        >
                          <OverlayTrigger
                            placement="bottom"
                            overlay={
                              <Tooltip id="action-tooltip">Action</Tooltip>
                            }
                          >
                            <SVGComponent iconName="Icon-export1" />
                          </OverlayTrigger>
                        </Dropdown.Toggle>

                        <Dropdown.Menu className="export_dropdown h-auto">
                          <Dropdown.Item
                            role="button"
                            onClick={() => {
                              handleGotoNDCDetails(cellInfo.data);
                            }}
                            disabled={!hasAccess}
                          >
                            {' '}
                            Go to NDC Dispute details
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  );
                },
                TextBoxRender: (cellInfo) => {
                  const name = cellInfo?.value;
                  if (name && name.length > 20) {
                    return (
                      <OverlayTrigger
                        placement="bottom"
                        overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
                      >
                        <div>{name}</div>
                      </OverlayTrigger>
                    );
                  }
                  return <div>{name}</div>;
                },
              }}
              info={{ firstInfo, secondInfo, thirdInfo, fourthInfo }}
            />{' '}
          </div>
        )}
      </div>
      <CommonModal
        open={openDlg}
        className="dialog-420"
        viewAction
        viewHeader
        onOk={() => {
          if (dlgTxt && !validateDate(dlgTxt).length) {
            dispatch(
              updateRecapMailoutDate({
                mfgId: manufactureID[0]?.manufacturerID,
                rebateProgramCode: getRebateProgramName?.rebateProgramCd,
                startQtr:
                  dateRange[requestCurrentDisData?.qtrSelected]?.beginDate,
                endQtr: dateRange[requestCurrentDisData?.qtrSelected]?.endDate,
                asQtrOpt: qtrSel,
                asDrugSel: drugSel,
                recapMailOutDT: moment(dlgTxt).format('MM/DD/YYYY'),
              })
            );
            setOpenDlg(false);
            setDlgErr(null);
            setDlgTxt('');
          }
        }}
        okTitle="Ok"
        disableOk={!dlgTxt || dlgErr}
        onClose={() => {
          setOpenDlg(false);
          setDlgErr(null);
          setDlgTxt('');
        }}
        closeTitle="Cancel"
        modalTitle="Record Recap Mailout Date"
        autoFocus
        childrenComponent={
          <div className="form-wrapper">
            <div className="mui-custom-form mandate-fields">
              <TextField
                className="mb-3"
                id="filename"
                inputProps={{ id: 'filename' }}
                label="Record Recap Mailout Date"
                required
                autoFocus
                InputLabelProps={{ shrink: true }}
                data-testid="filename-input"
                value={dlgTxt}
                onChange={(e) => {
                  setDlgTxt(e.target.value);
                  setDlgErr(null);
                }}
                onBlur={(e) => {
                  if (!e.target.value)
                    setDlgErr('Record Recap Mailout Date is required.');
                  else if (
                    e.target.value &&
                    validateDate(e.target.value).length
                  )
                    setDlgErr(START_DATE_INVALID);
                  else {
                    setDlgErr(null);
                    setDlgTxt(autoFormateDate(e.target.value));
                  }
                }}
                error={dlgErr ? true : false}
                helperText={dlgErr ? dlgErr : ''}
              />
            </div>
          </div>
        }
      />
      <CommonModal
        open={opnNullDlg}
        className="dialog-420"
        viewAction
        viewHeader
        onOk={() => {
          setOpnNullDlg(false);
        }}
        okTitle="Ok"
        onClose={() => {
          setOpnNullDlg(false);
        }}
        modalTitle="Record Recap Mailout Date"
        autoFocus
        childrenComponent={'No qualifying Record Found'}
      />
    </div>
  );
};

export default DisplayDisputeRecapitulation;
